/* NODE MODULES */

/* CONTEXT */

/* UI APP SHELL */

/* UI DESIGN SYSTEM */

/* UI COMPONENTS */

/* SERVICES */

/* UTILS & CONFIG */

/* TYPES */

export const formatStringToKebabCase = (stringToFormat) => {
    return stringToFormat
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, "-")
        .toLowerCase();
};


// WEBPACK FOOTER //
// ./src/utils/string.js